import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "nr-select field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = ["required", "aria-required"]
const _hoisted_4 = { class: "nr-select-option-container" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "nr-button-delete-container"
}
const _hoisted_8 = {
  key: 0,
  class: "vs__selected tag is-black"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "infinite-scroll-trigger vs__dropdown-option"
}
const _hoisted_12 = {
  key: 0,
  class: "required-field"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_VueSelect = _resolveComponent("VueSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NrFormLabel, {
      class: _normalizeClass([
        'nr-label',
        { 'is-sr-only': _ctx.hideLabel },
        { 'required-label': _ctx.attrs?.required }
      ]),
      id: `${_ctx.id}__label`,
      for: _ctx.id
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "label", {}, () => [
          _createTextVNode("Select label")
        ])
      ]),
      _: 3
    }, 8, ["class", "id", "for"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VueSelect, _mergeProps(_ctx.attrs, {
        "onUpdate:modelValue": _ctx.onInput,
        "onOption:created": _ctx.onOptionCreate,
        onOpen: _ctx.handleOpen,
        ref: "select",
        class: _ctx.searchClassnames,
        inputId: _ctx.id,
        deselectFromDropdown: true,
        getOptionKey: _ctx.getOptionKey,
        options: _ctx.sanitizedOptions,
        "calculate-position": _ctx.withPopper
      }), {
        search: _withCtx((search) => [
          _createElementVNode("input", _mergeProps({
            type: "search",
            class: "vs__search"
          }, search.attributes, _toHandlers(search.events, true), {
            required: _ctx.attrs?.required,
            "aria-required": _ctx.attrs?.required,
            onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSearchFocus && _ctx.handleSearchFocus(...args))),
            onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSearchBlur && _ctx.handleSearchBlur(...args))),
            onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validateOnFocusOut && _ctx.validateOnFocusOut(...args)))
          }), null, 16, _hoisted_3)
        ]),
        "selected-option": _withCtx(({ ...option }) => [
          (_ctx.$attrs.label)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(`vs__select-option-${option.textColor}`)
              }, _toDisplayString(option[_ctx.$attrs.label as string]), 3))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(`vs__select-option-${option.textColor}`)
              }, _toDisplayString(option.label), 3))
        ]),
        option: _withCtx(({ ...option }) => [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.$attrs.label)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(option[_ctx.$attrs.label as string]), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(option.label), 1)),
            (_ctx.hasDelete)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_NrIconButton, {
                    class: "nr-button-delete",
                    variant: "minimal-neutral",
                    size: "small",
                    icon: { name: 'trash-alt', type: 'regular' },
                    "aria-label": `Delete ${
                  _ctx.$attrs.label ? option[_ctx.$attrs.label as string] : option.label
                }`,
                    onClick: _withModifiers(($event: any) => (_ctx.onDelete(option)), ["stop"])
                  }, null, 8, ["aria-label", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        "selected-option-container": _withCtx((optionContainer) => [
          (optionContainer.multiple)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.$attrs.label)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(optionContainer.option[_ctx.$attrs.label as string]), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(optionContainer.option.label), 1)),
                _createVNode(_component_NrIconButton, {
                  class: "vs__deselect vs__clear",
                  variant: "minimal-neutral",
                  size: "small",
                  icon: { name: 'times', type: 'regular' },
                  disabled: optionContainer.disabled,
                  "aria-label": `Deselect ${_ctx.parseOptionLabel(
                  optionContainer.option
                )}`,
                  onClick: ($event: any) => (_ctx.handleSelectedOptionClick(optionContainer))
                }, null, 8, ["disabled", "aria-label", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        "list-footer": _withCtx(() => [
          (_ctx.hasMore)
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, " Loading more options... "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["onUpdate:modelValue", "onOption:created", "onOpen", "class", "inputId", "getOptionKey", "options", "calculate-position"])
    ]),
    (_ctx.showRequiredText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, " This field is required. "))
      : _createCommentVNode("", true)
  ]))
}